import Image from 'next/image';

import { Box, chakra, Flex, Heading, List, ListItem, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

// TODO: refactor this data into Sanity
const stories: Array<{
  country: string;
  imageSrc: string;
  title: string;
  description: string;
  stats: Array<{
    title: string;
    text: string;
  }>;
  testimonial: {
    quote: string;
    name: string;
    title: string;
  };
}> = [
  {
    country: 'Egypt',
    imageSrc: '/images/egypt.svg',
    title: 'Fueling economic growth in Egypt',
    description:
      'Udacity’s partnership with Egypt enabled citizens to win high-paying roles in government by developing software development talent.',
    stats: [
      {
        title: '12x ROI',
        text: 'for the Egyptian government',
      },
    ],
    testimonial: {
      quote:
        "We're bringing…know-how to our young population to prepare them to compete in the global market. This program is…about ensuring that graduates improve their livelihoods and, in turn, benefit the economy and transform Egypt into a tech hub.",
      name: 'H.E. Dr. Amr Talaat',
      title: "Egypt's Minister of Communications and Information Technology",
    },
  },
  {
    country: 'Saudi Arabia',
    imageSrc: '/images/saudi-arabia.svg',
    title: 'Empowering employment in Saudi Arabia',
    description:
      'Udacity helped the Misk Academy create employment opportunities for thousands of individuals, by providing them with Nanodegree programs that certified job-ready digital talent for a transformed workforce.',
    stats: [
      {
        title: '50%',
        text: 'completion rate and growing for Misk Academy’s ambitious target of employing 40,000 individuals by 2025',
      },
      {
        title: '7,029',
        text: 'Saudi Arabians that have landed jobs or promotions with a Nanodegree program',
      },
    ],
    testimonial: {
      quote:
        'Nothing compares to…Udacity courses. These opportunities helped me ace an elite full-time job as a digital marketing manager. I am working…to help new generations graduate from Nanodegree programs and find proper jobs.',
      name: 'Abdurrahman Alshanquiti',
      title: 'Udacity student, Misk Academy, Saudi Arabia',
    },
  },
];

const title = 'Success Stories';

export function SuccessStoriesSection() {
  return (
    <Box
      as='section'
      padding={{
        base: '40px 0px',
        md: '80px 0px 120px',
      }}
    >
      <ContentContainer>
        <Heading
          as='h2'
          size='marketing-5xl'
          textAlign='center'
          marginBottom={{
            base: '40px',
            md: '64px',
          }}
        >
          {title}
        </Heading>
        <Flex
          flexDir='column'
          position='relative'
          gap={{
            base: '64px',
            md: '80px',
          }}
        >
          <Box
            bottom='0px'
            left='0px'
            position='absolute'
            right='0px'
            top='0px'
            display={{
              base: 'none',
              md: 'block',
            }}
          >
            <Image
              alt=''
              src='/images/backgrounds/globe-lines.svg'
              style={{
                pointerEvents: 'none',
              }}
              fill
            />
          </Box>
          {stories.map((story, idx) => (
            <Flex
              key={story.country}
              as='article'
              position='relative'
              flexFlow={{
                md: idx % 2 === 0 ? 'row' : 'row-reverse',
              }}
              flexWrap={{
                base: 'wrap',
                md: 'unset',
              }}
              gap={{
                base: '24px',
                md: '80px',
              }}
            >
              <Box
                flex={{
                  md: '1 2 498px',
                }}
              >
                <Box marginBottom='24px'>
                  <Image alt={story.country} height={64} src={story.imageSrc} width={64} />
                </Box>
                <Box
                  marginBottom={{
                    base: '24px',
                    md: '40px',
                  }}
                >
                  <Heading as='h3' marginBottom='16px' size='marketing-4xl'>
                    {story.title}
                  </Heading>
                  <Text>{story.description}</Text>
                </Box>
                <List display='flex' flexDir='column' gap='16px'>
                  {story.stats.map((stat, idx) => (
                    <ListItem
                      key={idx}
                      backgroundColor='accent.sky.100'
                      borderRadius='base'
                      display='flex'
                      flexDir='column'
                      padding='24px'
                    >
                      <Heading as='p' color='blue.700' fontWeight='500' marginBottom='8px' size='marketing-5xl'>
                        {stat.title}
                      </Heading>
                      <Text fontWeight='600' size='caption'>
                        {stat.text}
                      </Text>
                    </ListItem>
                  ))}
                </List>
              </Box>
              <Flex
                backgroundColor='blue.800'
                borderRadius='6px 6px 26px 6px'
                color='white'
                flexDir='column'
                justifyContent='center'
                flex={{
                  md: '0 1 540px',
                }}
                padding={{
                  base: '40px 16px',
                  md: '56px',
                }}
              >
                <chakra.blockquote>
                  <Heading
                    as='p'
                    marginBottom='48px'
                    size='h2'
                    sx={{
                      '&::before': {
                        content: 'open-quote',
                      },
                      '&::after': {
                        content: 'close-quote',
                      },
                    }}
                  >
                    {story.testimonial.quote}
                  </Heading>
                  <chakra.footer>
                    <Heading as='span' color='accent.lime' display='block' marginBottom='8px' size='marketing-lg'>
                      {story.testimonial.name}
                    </Heading>
                    <Box as='span' display='block'>
                      {story.testimonial.title}
                    </Box>
                  </chakra.footer>
                </chakra.blockquote>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
